<template>
  <v-flex class="pl-2 pr-2">
    <v-layout align-start justify-start row class="ml-3 mb-4">
      <v-icon color="primary" style="font-size: 50px;">assessment</v-icon>
      <h2
        :style="`color: ${$vuetify.theme.primary}`"
        class="mt-2 ml-2"
      >Account exact csv</h2>
    </v-layout>
    <v-layout row wrap justify-space-around>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="sales"
          item-key="name"
          :search="filters"
          :custom-filter="customFilter"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr class="center_table">
              <td>{{ props.item.Name }}</td>
              <td>
                <v-icon
                  v-if="props.item.SaleCsv !== 'NULL'
                  && props.item.SaleCsv !== ''"
                  @click="getSaleDetailsForCSV(props.item)"
                >
                  description
                </v-icon>
              </td>
              <td>
                <v-icon
                  v-if="props.item.FeeCsv !== 'NULL'
                  && props.item.FeeCsv !== ''"
                  @click="getFeeDetailsForCSV(props.item)"
                >
                  description
                </v-icon>
              </td>
              <td>
                <v-icon
                  v-if="props.item.DirectDebitXml !== 'NULL'
                  && props.item.DirectDebitXml !== ''"
                  @click="getDirectDebitDetails(props.item)"
                >
                  description
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
  import * as dssRequest from "@/api/dssRequest";
  import appConfig from "../../../config/app_config";
  import BaseObject from "@/objects/BaseObject";
  import _ from "lodash";
  import { mapGetters } from "vuex";
  import pdfMake from "pdfmake";
  import * as pdfFonts from "pdfmake/build/vfs_fonts";

  export default {
    name: "Account_ExactCsv",
    components: {},
    computed: mapGetters({
      currentAccountId: "getCurrentAccountId"
    }),
    data() {
      return {
        filters: {
          search: "",
          Status: ""
        },


        partnerObjs: [],
        selectedPartner: {},

        sales: [],
        saleDetails: [],
        admin: false,

        csvContent: "",

        headers: [
          {
            text: this.$translate('NAME'),
            value: "Name",
            align: "left",
            sortable: false
          },
          {
            text: "Sales CSV",
            value: "SaleCsv",
            align: "left",
            sortable: false
          },
          {
            text: "Fees CSV",
            value: "FeeCsv",
            align: "left",
            sortable: false
          },
          {
            text: "Direct debit XML",
            value: "DirectDebitXml",
            align: "left",
            sortable: false
          }
        ]
      };
    },

    mounted() {
      if (this.$store.getters["auth/userLevel"] >= 9)
        this.admin = true;
      this.getExactCSVs();
    },

    methods: {
      getExactCSVs(){
        const payload = {
          FunctionId: "AccountFunctionLibrary::getExactCsvs",
        };

        dssRequest.doRequest(
          response => {
            console.log(
              "The call for 'getExactCSVs' on - Account_ExactCsv.vue - was successful",
              response
            );
            if (!response.data.hasOwnProperty('ExactCsvs')) {
              // window.EventBus.fire('triggerGenericErrorDialog', 'W_GEC_001');
              return;
            }
            this.sales = BaseObject._createArrayWithObjects(response.data.ExactCsvs);

            // // sort sales based on date
            // this.sales.sort((a, b) => {
            //   let a1 = a.Date.split("-").join("");
            //   let b1 = b.Date.split("-").join("");
            //   return a1 < b1 ? 1 : a1 > b1 ? -1 : 0;
            // });
          },
          error => {
            console.log(
              "The call for 'getExactCSVs' on - Account_ExactCsv.vue - was not successful ",
              error,
            );
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GEC_001');
          },
          "communicateWithDBLibrary",
          this.currentAccountId,
          payload,
          600000,
          false
        );
      },

      getSaleDetailsForPDF(item) {

        if (item.hasOwnProperty('SaleBillPdf')) {
          const source = "data:application/pdf;base64," + item.SaleBillPdf;
          const downloadLink = document.createElement("a");
          const fileName = item.SaleBillNumber + ".pdf";
          downloadLink.href = source;
          downloadLink.download = fileName;
          downloadLink.click();
        }
      },
      getFeeDetailsForCSV(item) {
        if (item.hasOwnProperty('FeeCsv')) {
          const source = "data:application/octet-stream;base64," + item.FeeCsv;
          const downloadLink = document.createElement("a");
          const fileName = "Fees_" + item.Name + ".csv";
          downloadLink.href = source;
          downloadLink.download = fileName;
          downloadLink.click();
        }
      },
      getSaleDetailsForCSV(item) {
        if (item.hasOwnProperty('SaleCsv')) {
          const source = "data:application/octet-stream;base64," + item.SaleCsv;
          const downloadLink = document.createElement("a");
          const fileName = "Sales_" + item.Name + ".csv";
          downloadLink.href = source;
          downloadLink.download = fileName;
          downloadLink.click();
        }
      },
      getDirectDebitDetails(item) {
        if (item.hasOwnProperty('DirectDebitXml')) {
          const source = "data:application/octet-stream;base64," + item.DirectDebitXml;
          const downloadLink = document.createElement("a");
          const fileName = "DirectDebit_" + item.Name + ".xml";
          downloadLink.href = source;
          downloadLink.download = fileName;
          downloadLink.click();
        }
      },
      customFilter(items, filters, filter, headers) {
        // Init the filter class.
        const cf = new this.$MultiFilters(items, filters, filter, headers);

        cf.registerFilter("search", function(searchWord, items) {
          if (searchWord.trim() === "") return items;

          return items.filter(item => {
            return item.Component.toLowerCase().includes(
              searchWord.toLowerCase()
            );
          }, searchWord);
        });

        cf.registerFilter("Status", function(Status, items) {
          if (Status.trim() === "") return items;

          return items.filter(item => {
            return item.Status.toLowerCase() === Status.toLowerCase();
          }, Status);
        });

        // Its time to run all created filters.
        // Will be executed in the order they were defined.
        return cf.runFilters();
      },

      /**
       * Handler when user input something at the "Filter" text field.
       */
      filterSearch(val) {
        this.filters = this.$MultiFilters.updateFilters(this.filters, {
          search: val
        });
      },

      /**
       * Handler when user select some Status at the "Status" select.
       */
      filterStatus(val) {
        if (val == "All") {
          val = "";
        }
        this.filters = this.$MultiFilters.updateFilters(this.filters, {
          Status: val
        });
      }
    }
  };
</script>

<style lang="scss", scoped>
  .center_table > td {
    text-align: center;
  }
</style>
